import styled from 'styled-components';

export const StyledProgressCircle = styled.div`
  display: grid;
  place-items: center;
  width: fit-content;

  > * {
    grid-column: 1 / -1;
    grid-row: 1 / -1;
  }

  svg {
    transform: rotate(-90deg);

    .circle__progress {
      transition: stroke-dashoffset 300ms linear;
    }
  }

  .progress__value {
    font-size: 16px;
    font-weight: 600;
  }

  .progress__symbol {
    font-size: 12px;
    font-weight: 300;
  }
`;
